<div style="width:98%" *ngIf="offices.length > 0">
  <span> <button class="btn btn border" (click)="saveOfficeCommittees()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><br>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <label>
          Ämbete
        </label>
        <p-select appendTo="body" [options]="offices" [filter]="true" filterBy="label" [showClear]="true" formControlName="officeId" (onChange)="setOffice($event)"></p-select>
      </div>
      <div class="col-md-12">
        <label>
          Utskott
        </label>
        <p-select appendTo="body" [options]="committees" [filter]="true" filterBy="label" [showClear]="true" formControlName="committeeId" [style]="{'width':'100%'}" (onChange)="setCommittee($event)"></p-select>
      </div>
    </div>
  </form>
</div>